import axios from "axios";
import { decrypt, encrypt } from "../encryt";
import { Cookie } from "../index";
import Cookies from "js-cookie";

const baseURL = process.env.REACT_APP_URL_CLIENT;
const timeout = 16000;

// let token2 = Cookies.get("token") ? decrypt(Cookie.get({ name: "token" })) : null;
const instance = axios.create({
  baseURL,
  timeout,
  headers: {
    "Content-Type": "application/json",
    // "Authorization": `Bearer ${token2}`
  },
});

instance.interceptors.request.use(async (config) => {
  var token = Cookies.get("token")
    ? await decrypt(Cookie.get({ name: "token" }))
    : "";
  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

instance.setToken = (token) => {
  instance.defaults.headers["Authorization"] = `Bearer ${token}`;
  Cookie.set({ name: "token", data: encrypt(token) });
};

instance.interceptors.response.use(undefined, async (err) => {
  const error = err.response;
  if (error && error.status === 401) {
    Cookies.remove("refreshToken");
    Cookies.remove("token");
    Cookies.remove("company");
    window.location.replace("/login");
  }
});

export default instance;
